export const REGION = "eu-central-1";
export const CLIENT_ID = "nnp66dgsis9il2i7ki2oe0c6m";
export const TABLE_NAME = "CarpetTable";
export const IDENTITY_POOL_ID = "eu-central-1:d39e45c3-3de2-47ff-b0d8-7bd9a4287702"; // Identity Pool ID
export const USER_POOL_ID = "eu-central-1_ZIgvPugtX"; // Cognito User Pool ID
export const BUCKET_NAME = "teppich-carpet-images";